import { render, staticRenderFns } from "./WidgetOrderbox.vue?vue&type=template&id=1276cb4a&"
import script from "./WidgetOrderbox.vue?vue&type=script&lang=js&"
export * from "./WidgetOrderbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1276cb4a')) {
      api.createRecord('1276cb4a', component.options)
    } else {
      api.reload('1276cb4a', component.options)
    }
    module.hot.accept("./WidgetOrderbox.vue?vue&type=template&id=1276cb4a&", function () {
      api.rerender('1276cb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/WidgetOrderbox.vue"
export default component.exports